module.exports = __webpack_public_path__ + "assets/GTAmerica-ExtendedRegular.ttf";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-ExtendedRegular.ttf
// module id = 1011
// module chunks = 19